import { useState, useEffect } from "react";
import {
  Typography,
  Row,
  Col,
  Input,
  Select,
  Image,
  InputNumber,
  Alert,
  notification,
} from "antd";
import { useDispatch, useSelector } from "react-redux";

import noimage from "../../images/noimage.jpg";
import {
  setAllCompanyNames,
  setAllDepartmentNames,
  setAllPositionNames,
} from "../../redux/actions/mainAction";

const EditProfile = () => {
  const [employeeName, setEmployeeName] = useState("");
  const [employeeImage, setEmployeeImage] = useState("");
  const [employeeImageState, setEmployeeImageState] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [oldCompanyName, setOldCompanyName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [oldDepartmentName, setOldDepartmentName] = useState("");
  const [positionName, setPositionName] = useState("");
  const [oldPositionName, setOldPositionName] = useState("");
  const [employeeEmail, setEmployeeEmail] = useState("");
  const [employeePhone, setEmployeePhone] = useState("");
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const [showAlertIncorrectEmail, setShowAlertIncorrectEmail] = useState(false);
  const [showAlertForPass, setShowAlertForPass] = useState(false);
  const [showAlertForPasslength, setShowAlertForPasslength] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const dispatch = useDispatch();
  const { MainResponse } = useSelector((state) => state);
  const [api, contextHolder] = notification.useNotification();

  const userId = JSON.parse(localStorage.getItem("user"))._id;

  useEffect(() => {
    getAnEmployee(userId);
    getAllCompanyNames();
    getAllDepartmentNames();
    getAllPositionNames();
  }, []);

  const getAnEmployee = async (userId) => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-employee/${userId}`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    setEmployeeName(result.employeeName);
    setEmployeeImage(result.employeeImage);
    setCompanyName(result.companyName);
    setOldCompanyName(result.companyName);
    setPositionName(result.positionName);
    setOldPositionName(result.positionName);
    setDepartmentName(result.departmentName);
    setOldDepartmentName(result.departmentName);
    setEmployeeEmail(result.employeeEmail);
    setEmployeePhone(result.employeePhone);
  };

  const getAllCompanyNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-company-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllCompanyNames(uniqueResults));
  };

  const getAllDepartmentNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-department-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllDepartmentNames(uniqueResults));
  };

  const getAllPositionNames = async () => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/get-position-names/`,
      {
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    const uniqueResults = result.filter((item, index, array) => {
      return array.findIndex((obj) => obj.value === item.value) === index;
    });
    dispatch(setAllPositionNames(uniqueResults));
  };

  const handleChangeCompany = (value) => {
    setCompanyName(value);
  };

  const handleChangeDepartment = (value) => {
    setDepartmentName(value);
  };

  const handleChangePosition = (value) => {
    setPositionName(value);
  };

  const uploadImageHandler = (event) => {
    const file = event.target.files[0];
    setEmployeeImage(file);
    const reader = new FileReader();

    reader.onload = () => {
      setEmployeeImageState(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const deleteImageHandler = () => {
    setEmployeeImageState(noimage);
    setEmployeeImage("Image deleted");
  };

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Məlumatlarınız yeniləndi!",
    });
  };

  const prepareToSave = () => {
    if (isValidEmail(employeeEmail)) {
      if (password.length > 0) {
        if (
          employeeName.length > 0 &&
          companyName.length > 0 &&
          positionName.length > 0 &&
          departmentName.length > 0 &&
          employeeEmail.length > 0 &&
          employeePhone.length > 0 &&
          password.length > 0 &&
          repeatPassword.length > 0
        ) {
          checkPasswordLength();
          setShowAlert(false);
        } else {
          setShowAlert(true);
        }
      } else {
        updateEmployeeWithoutPassword();
      }
    } else {
      setShowAlertIncorrectEmail(true);
    }
  };

  const checkPasswordLength = () => {
    if (password.length > 5) {
      setShowAlertForPasslength(false);
      updateEmployee();
    } else {
      setShowAlertForPasslength(true);
    }
  };

  const updateEmployeeWithoutPassword = async () => {
    if (
      employeeName &&
      companyName &&
      positionName &&
      departmentName &&
      employeeEmail &&
      employeePhone
    ) {
      const formData = new FormData();
      if (typeof employeeImage !== "string") {
        formData.append("employeeImage", employeeImage, employeeImage.name);
      }

      if (employeeImage === "Image deleted") {
        formData.append("employeeImage", employeeImage);
      }
      setButtonDisable(true);

      formData.append("employeeName", employeeName);
      formData.append("companyName", companyName);
      formData.append("oldCompanyName", oldCompanyName);
      formData.append("positionName", positionName);
      formData.append("oldPositionName", oldPositionName);
      formData.append("departmentName", departmentName);
      formData.append("oldDepartmentName", oldDepartmentName);
      formData.append("employeeEmail", employeeEmail);
      formData.append("employeePhone", employeePhone);

      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/employee-update/${userId}`,
        {
          method: "put",
          body: formData,
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )}`,
          },
        }
      );
      result = await result.json();
      if (result) {
        setButtonDisable(false);

        localStorage.setItem("user", JSON.stringify(result));
        openNotificationWithIcon("success");
        setShowAlert(false);
        setShowAlertIncorrectEmail(false);
        setShowAlertForPass(false);
        setShowAlertForPasslength(false);
        setPassword("");
        setRepeatPassword("");
      }
    } else {
      setShowAlert(true);
    }
  };

  const updateEmployee = async () => {
    if (password === repeatPassword) {
      const formData = new FormData();
      if (typeof employeeImage !== "string") {
        formData.append("employeeImage", employeeImage);
      }

      if (employeeImage === "Image deleted") {
        formData.append("employeeImage", employeeImage);
      }
      setButtonDisable(true);

      formData.append("employeeName", employeeName);
      formData.append("companyName", companyName);
      formData.append("oldCompanyName", oldCompanyName);
      formData.append("positionName", positionName);
      formData.append("oldPositionName", oldPositionName);
      formData.append("departmentName", departmentName);
      formData.append("oldDepartmentName", oldDepartmentName);
      formData.append("employeeEmail", employeeEmail);
      formData.append("employeePhone", employeePhone);
      formData.append("password", password);
      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/employee-update/${userId}`,
        {
          method: "put",
          body: formData,
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )}`,
          },
        }
      );
      result = await result.json();
      if (result) {
        setButtonDisable(true);
        localStorage.setItem("user", JSON.stringify(result));
        openNotificationWithIcon("success");
        setShowAlert(false);
        setShowAlertIncorrectEmail(false);
        setShowAlertForPass(false);
        setShowAlertForPasslength(false);
        setPassword("");
        setRepeatPassword("");
      }
    } else {
      setShowAlertForPass(true);
    }
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <>
      {contextHolder}

      {showAlertIncorrectEmail && (
        <Alert
          onClose={() => setShowAlertIncorrectEmail(false)}
          message="Diqqət!"
          description="E-poçt hesabında səhv var!"
          type="warning"
          showIcon
          closable
        />
      )}

      {showAlertForPasslength && (
        <Alert
          onClose={() => setShowAlertForPasslength(false)}
          message="Diqqət!"
          description="Şifrələr 5 simvoldan çox olmalıdır!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlertForPass && (
        <Alert
          onClose={() => setShowAlertForPass(false)}
          message="Diqqət!"
          description="Şifrələriniz eyni deyil!"
          type="warning"
          showIcon
          closable
        />
      )}
      {showAlert && (
        <Alert
          onClose={() => setShowAlert(false)}
          message="Diqqət!"
          description="Zəhmət olmasa boş sahələri doldurun!"
          type="warning"
          showIcon
          closable
        />
      )}
      <Row className="add-row">
        <Col style={{ textAlign: "center" }} span={5}>
          <Row style={{ textAlign: "center" }}>
            {employeeImageState.length > 1 ? (
              <Image className="profile-edit-image" src={employeeImageState} />
            ) : (
              <Image className="profile-edit-image" src={employeeImage} />
            )}
          </Row>
          <Row>
            <Col span={12}>
              <label htmlFor="upload" className="success-button">
                Dəyiş
              </label>
              <input
                id="upload"
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                onChange={uploadImageHandler}
              />
            </Col>
            <Col span={12}>
              <button onClick={deleteImageHandler} className="delete-button">
                Sil
              </button>
            </Col>
          </Row>
        </Col>

        <Col span={1}></Col>
        <Col span={18}>
          <Row>
            <Col className="profile-fields-area" span={12}>
              <Typography.Text className="add-title">
                Ad və soyad
              </Typography.Text>
              <Input
                className="add-input"
                size="large"
                value={employeeName}
                onChange={(e) => setEmployeeName(e.target.value)}
              />

              <Typography.Text className="add-title">Şirkət</Typography.Text>
              <Select
                size="large"
                value={companyName}
                onChange={handleChangeCompany}
                className="add-dropdown"
                options={MainResponse.allCompanyNames}
              />

              <Typography.Text className="add-title">Şöbə</Typography.Text>
              <Select
                size="large"
                value={departmentName}
                onChange={handleChangeDepartment}
                className="add-dropdown"
                options={MainResponse.allDepartmentNames}
              />

              <Typography.Text className="add-title">Vəzifə</Typography.Text>
              <Select
                size="large"
                value={positionName}
                onChange={handleChangePosition}
                className="add-dropdown"
                options={MainResponse.allPositionNames}
              />
            </Col>
            <Col className="profile-fields-area" span={12}>
              <Typography.Text className="add-title">E-poçt</Typography.Text>
              <Input
                className="add-input"
                size="large"
                value={employeeEmail}
                onChange={(e) =>
                  setEmployeeEmail(e.target.value.toLowerCase().trim())
                }
              />

              <Typography.Text className="add-title">Telefon</Typography.Text>
              <InputNumber
                className="add-input"
                size="large"
                onChange={(e) => setEmployeePhone(e)}
                value={employeePhone}
              />

              <Typography.Text className="add-title">Şifrə</Typography.Text>
              <Input.Password
                className="add-input"
                size="large"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
              />

              <Typography.Text className="add-title">
                Şifrənin təkrarı
              </Typography.Text>
              <Input.Password
                className="add-input"
                size="large"
                value={repeatPassword}
                onChange={(e) => setRepeatPassword(e.target.value)}
                type="password"
              />
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <button onClick={prepareToSave} className="success-button">
                Təsdiq Et
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default EditProfile;
